import { mutationOptions } from '@tanstack/react-query';
import API from '@/api';
import { mutationKeys } from '@/api/utils/mutationKeys';

export const withdrawMutationOptionsGeneric = mutationOptions({
  mutationKey: mutationKeys.withdraw,
  // Explicitly timeout and handle the ECONNABORTED error here
  mutationFn: (amount: number) => API.paymentProvider.withdraw(amount, { timeout: 30_000 }),
});
